module.exports = __webpack_public_path__ + "static/slide-2_website_en-21639623c65b6236b016e4e90ecf3352.jpg";